import * as THREE from 'three';
import {GUI} from 'three/examples/jsm/libs/dat.gui.module.js';

export const createPanel = (container, actions, mixer, scene) => {
    const panel = new GUI({width: 310, autoPlace: false});
    container.parent().closest('.contest-work__preview').prepend(panel.domElement);

    const folder2 = panel.addFolder('Activation/Deactivation');
    const folder3 = panel.addFolder('Pausing/Stepping');
    const folder6 = panel.addFolder('General Speed');
    const folder8 = panel.addFolder('Background');

    function deactivateAllActions() {
        actions.forEach(function (action) {
            action.stop();
        });
    }

    function activateAllActions() {
        actions.forEach(function (action) {
            action.play();
        });
    }

    function pauseContinue() {
        if (actions[0].paused) {
            unPauseAllActions(actions);
        } else {
            pauseAllActions(actions);
        }
    }

    function pauseAllActions() {
        actions.forEach(function (action) {
            action.paused = true;
        });
    }

    function unPauseAllActions() {
        actions.forEach(function (action) {
            action.paused = false;
        });
    }

    function modifyTimeScale(speed) {
        mixer.timeScale = speed;
    }

    function changeBackgroundColor(color) {
        scene.background.set(color);
        scene.fog = new THREE.Fog(color, 0.1, 2000);
    }

    let settings = {
        'deactivate all': deactivateAllActions,
        'activate all': activateAllActions,
        'pause/continue': pauseContinue,
        'modify step size': 0.05,
        'modify time scale': 1.0,
        'color': '#a0a0a0'
    };

    folder2.add(settings, 'deactivate all');
    folder2.add(settings, 'activate all');
    folder3.add(settings, 'pause/continue');
    folder6.add(settings, 'modify time scale', 0.0, 1.5, 0.01).onChange(modifyTimeScale);
    folder8.addColor(settings, 'color').onChange(changeBackgroundColor);

    panel.close();
}
